import { render, staticRenderFns } from "./PaymentSuccessCard.vue?vue&type=template&id=1b9c1634&scoped=true"
import script from "./PaymentSuccessCard.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccessCard.vue?vue&type=style&index=0&id=1b9c1634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9c1634",
  null
  
)

export default component.exports